<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <!--begin::Card header-->
      <div class="border-bottom">
        <div class="row ps-8 pe-8 pt-3 pb-3 align-items-center">
          <div class="col-lg-5">
            <h3 class="fw-bolder m-0 fs-4 text-gray-800 m-3">
              {{ translate("Menu_List_Projects") }}
            </h3>
          </div>
          <div class="col-lg-3"></div>
          <div class="col-lg-4">
            <div class="row pt-2 pb-2">
              <div class="d-flex align-items-center position-relative my-1">
                <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <i
                    :class="`bi bi-search fs-3 ${
                      inputValue !== '' ? 'text-gray-700' : ''
                    }`"
                  ></i>
                </span>
                <input
                  type="text"
                  @keydown.enter="searchCProject()"
                  class="form-control ps-15 form-control-sm input-Filter-search"
                  v-model="inputValue"
                  @keyup.delete="inputNull()"
                  :Placeholder="translate('project_new_project_search')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--begin::Card header-->

      <div
        class="d-flex justify-content-between p-8 pt-6 pb-6 border-bottom"
        style="background: #fbfbfb"
      >
        <div
          v-show="CProjectList.length > 0"
          class="form-check form-check-custom form-check-solid"
          style="margin-left: 2.3rem !important"
        >
          <input
            ref="checkAll"
            class="form-check-input"
            type="checkbox"
            @change="selectAll($event)"
            id="check-all"
          />
          <label
            class="form-check-label text-primary fw-bolder fs-7"
            style="margin-left: 1.3rem !important"
            for="check-all"
          >
            {{ translate("Select_All") }}
          </label>
        </div>
        <button
          v-show="CProjectList.filter((i) => i.checked === true).length > 0"
          @click="deleteCProject()"
          type="button"
          class="btn bg-white bg-hover-secondary btn-sm border position-relative ms-2 text-gray-700"
        >
          {{ translate("project_detail_location_button_remove_projects")
          }}<span
            class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
            >{{ CProjectList.filter((i) => i.checked === true).length }}</span
          >
        </button>
      </div>
      <!--begin::Body-->
      <div class="card-body pt-6 pb-2">
        <!--begin::Item-->

       
          <div
            v-for="(cProjectItem, index) in CProjectList"
            :key="index.Id"
            class="d-flex align-items-center mb-1 border rounded p-2"
          >
            <!--begin::Bullet-->
            <span class="bullet bullet-vertical h-40px bg-primary"></span>
            <!--end::Bullet-->

            <!--begin::Checkbox-->
            <div class="form-check form-check-custom form-check-solid mx-5">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                key=""
                v-model="cProjectItem.checked"
              />
            </div>
            <!--end::Checkbox-->

            <!--begin::Description-->
            <div class="flex-grow-1">
              <div
                class="d-flex flex-column position-relative"
            
              >
                <label
                  class="form-check-label col-form-label fw-bold p-0 "
                  for="check-remember">
                  {{ CProjectList[index].Name }}
                </label>
              </div>
            </div>
            <!--end::Description-->

            <span
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#add-project-modal"
              class="btn fs-7 fw-bolder bg-light-primary btn-sm text-primary p-1 ps-3 pe-3 me-2 d-flex"
              @click="propsUpdate(CProjectList[index].Id)"
            >
              {{ translate("customer_detail_button_edit") }}
            </span>

            <span
              type="button"
              class="badge fs-7 fw-bolder badge-white border"
              @click="deleteCProject(CProjectList[index])"
            >
              {{ translate("Delete") }}
            </span>
          </div>
     
      </div>

      <div class="row ps-8 pe-8 pt-5 pb-5 align-items-center">
        <div class="col-lg-8">
          <Pagination @onPage="onPage" :TotalData="records" />
        </div>

        <div class="col-lg-2"></div>
        <div class="col-lg-2">
          <div
            class="row align-items-center justify-content-end w-100 mx-0 m-2"
          >
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#add-project-modal"
              class="btn btn-primary align-self-center btn-sm ps-2 pe-2 mt-2 mb-2"
              @click="customerProfilEdit"
            >
              {{ translate("project_button_add_new") }}
            </button>
          </div>
        </div>
      </div>
      <AddProject :prorjectId="prorjectId" @closeModal="closeModal" />
    </div>
  </div>
</template>

<script setup>
import AddProject from "@/components/Admin/Customer-Modal/C-NewProjectComp.vue";
import ProjectModule from "@/store/modules/Customer/ProjectModule";
import { inject, ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
const store = useStore();
const Id = ref(null);
const lazyParams = ref({});
const inputValue = ref("");
const prorjectId = ref(0);
const selectedCProject = ref([]);
const checkAll = ref();
const block = ref(true);

const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const propsUpdate = (Id) => {
  prorjectId.value = Id;
};

const closeModal = () => {
  prorjectId.value = 0;
};

const onPage = (e) => {
  lazyParams.value.page = e.step.value;
  lazyParams.value.pageSize = e.pageSize.value;
  getAllCustomerProject(lazyParams.value);
};

const CProjectList = computed(() => store.getters["ProjectModule/_getPorject"]);
const records = computed(
  () => store.getters["LocationModule/_getTotalRecords"]
);

const totalRecords = computed(
  () => store.getters["ProjectModule/_getTotalRecords"]
);

const customerId = inject("customerId");
const getAllCustomerProject = () => {
  lazyParams.value.customerId = customerId;
  store.dispatch("ProjectModule/GET_ALL_PROJECTS", lazyParams.value).finally(() => (block.value = false));;
};

// onMounted ilk önce buranın yüklenmesini sağlar.

const selectAll = (event) => {
  CProjectList.value.forEach((item) => (item.checked = event.target.checked));
};

onMounted(() => {
  lazyParams.value = {
    page: 1,
    pageSize: 10,
    customerId: 0,
    name: null,
  };
  getAllCustomerProject();
});

const filters = ref({
  name: { value: null, matchMode: "contains" },
});

const searchCProject = () => {
  lazyParams.value.name = inputValue.value;

  // CProjectList.value[0].name = inputValue.value;
  getAllCustomerProject({ page: 1, pageSize: 10 });
};
const inputNull = () => {
  if (inputValue.value === "" || inputValue.value === null) {
    lazyParams.value.name = null;
    getAllCustomerProject({ page: 1, pageSize: 10 });
  }
};

const deleteCProject = (Item) => {
  let obj = [];
  let list = [];
  if (Item !== undefined) {
    obj.push(Item.Id);
    list.push(obj);
    list.push(lazyParams.value);
  } else {
    let value = CProjectList.value.filter((i) => i.checked === true);
    value.forEach((item) => {
      obj.push(item.Id);
    });
    list.push(obj);
    list.push(lazyParams.value);
  }

  store.dispatch("ProjectModule/DELETE_PROJECT", list);
};
</script>

<style>
s .locations-list {
  padding: 0%;
  width: 100%;
  max-height: 100vh;
  overflow: scroll;
  overflow-y: hidden;
}
</style>
